import { ConfigProductStorySpecifications } from "../../types/config";

export const configProductStorySpecifications: ConfigProductStorySpecifications =
  {
    "auto-duplex-printing": "Auto Duplex Printing",
    "auto-duplex-scanner": "Auto Duplex Scanner",
    connectivity: "Connectivity",
    "interface-type": "Interface Type",
    "number-of-inks-colours": "Number of Inks / Colours",
    "os-support": "OS Support",
    "paper-capacity-trays": "Paper Capacity / Trays",
    "paper-handling-sizes": "Paper Handling / Sizes",
    "print-speed": "Print Speed",
    "print-technology": "Print Technology",
    resolution: "Resolution",
    scanner: "Scanner",
    "keyboard-type": "Keyboard Type",
    "mouse-type": "Mouse Type",
    "operating-system-compatibility": "Operating System Compatibility",
    "other-features": "Other Features",
    "tracking-engine": "Tracking Engine",
    "wireless-technology": "Wireless Technology",
    features: "Features",
    "operating-system-support": "Operating System Support",
    "system-requirements": "System Requirements",
    miscellaneous: "Miscellaneous",
    "battery-and-charging": "Battery and Charging",
    "codecs-support": "Codecs Support",
    "driver-unit": "Driver Unit",
    "frequency-response": "Frequency Response",
    impedance: "Impedance",
    "sensitivity-(1khz)": "Sensitivity (1kHz)",
    microphone: "Microphone",
    "headphone-type": "Headphone Type",
    "weather-resistance": "Weather Resistance",
    "inputs-outputs": "Inputs / Outputs",
    "power-output": "Power Output",
    subwoofer: "Subwoofer",
    "surround-sound-capability": "Surround Sound Capability",
    "interface-and-controls": "Interface and Controls",
    ports: "Ports",
    "smart-home-support": "Smart Home Support",
    "voice-assistant-support": "Voice Assistant Support",
    "wireless-connectivity": "Wireless Connectivity",
    audio: "Audio",
    battery: "Battery",
    "io-ports": "I/O Ports",
    "operating-system": "Operating System",
    "processor-and-chipset": "Processor and Chipset",
    storage: "Storage",
    "system-memory": "System Memory",
    "graphics-and-display": "Graphics and Display",
    antenna: "Antenna",
    "frequency-range": "Frequency Range",
    interface: "Interface",
    "networking-standards": "Networking Standards",
    "number-of-nodes": "Number of Nodes",
    security: "Security",
    display: "Display",
    graphics: "Graphics",
    memory: "Memory",
    networking: "Networking",
    "aperture-range": "Aperture range",
    "auto-focus": "Auto Focus",
    "effective-pixels": "Effective pixels",
    "exposure-compensation": "Exposure Compensation",
    "exposure-control": "Exposure Control",
    "flash-modes": "Flash Modes",
    "focal-length-multiplier": "Focal Length Multiplier",
    "image-stabilization": "Image Stabilization",
    "iso-rating": "ISO rating",
    lens: "Lens",
    metering: "Metering",
    "recording-formats": "Recording Formats",
    sensor: "Sensor",
    "shutter-speed": "Shutter speed",
    "specialty-shooting-modes": "Specialty Shooting Modes",
    "storage-type": "Storage type",
    "zoom-ratio": "Zoom ratio",
    processor: "Processor",
    "ram-and-storage": "RAM and Storage",
    camera: "Camera",
    dimensions: "Dimensions",
    weight: "Weight",
    "protection-and-resistance": "Protection and Resistance",
    "mobile-network": "Mobile Network",
    "sim-configuration": "SIM Configuration",
    "drive-capacity": "Drive Capacity",
    "drive-type": "Drive Type",
    "io-interface": "I/O Interface",
    "drive-bays": "Drive Bays",
    "array-configuration": "Array Configuration",
    "management-features": "Management Features",
    "processor-and-memory": "Processor and Memory",
    "networking-support": "Networking Support",
    "random-read-write-speeds": "Random Read/Write Speeds",
    "sequential-read-write-speeds": "Sequential Read/Write Speeds",
    "controller-processor": "Controller/Processor",
    "flash-memory-type": "Flash Memory Type",
    "onboard-cache": "Onboard Cache",
    performance: "Performance",
    "ssd-capacity": "SSD Capacity",
    "ssd-format": "SSD Format",
    brightness: "Brightness",
    "contrast-ratio": "Contrast Ratio",
    "display-size": "Display Size",
    "io-connectivity": "I/O Connectivity",
    "autofocus-and-keystone-correction": "Autofocus and Keystone Correction",
    "lens-zoom": "Lens / Zoom",
    "operational-noise-level": "Operational Noise Level",
    "panel-type": "Panel Type",
    power: "Power",
    "projection-technology": "Projection Technology",
    "projector-type": "Projector Type",
    "rated-lifespan": "Rated Lifespan",
    wireless: "Wireless",
    network: "Network",
    sensors: "Sensors",
  };
